import { forwardRef, chakra } from '@chakra-ui/react';
import type { HTMLChakraProps } from '@chakra-ui/react';

import { SearchIcon } from '@frontend/components/src/components/mediaAndIcons/icons/iconSet';

import { useSearchInputStyles } from './SearchInputStylesContext';
import { useSearchInputContext } from './utils/SearchInputContext';

export type SearchInputLeftElementProps = HTMLChakraProps<'div'>;

export const SearchInputLeftElement = forwardRef<
  SearchInputLeftElementProps,
  'div'
>((props, ref) => {
  // Get props that are shared between search input
  const { value, isLiveMode } = useSearchInputContext();
  // Get field style from search input element custom theme
  const { element: elementStyles } = useSearchInputStyles();

  if (!isLiveMode) {
    return null;
  }

  return (
    <chakra.div
      ref={ref}
      __css={{ ...elementStyles, left: 0, pointerEvents: 'none' }}
      {...props}
    >
      <SearchIcon
        color={
          value && value !== '' ? 'interaction.main' : 'feature.placeholder'
        }
      />
    </chakra.div>
  );
});
SearchInputLeftElement.displayName = 'SearchInputLeftElement';
